jQuery(document).ready(function($){
    $(".cs-image-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        autoplay: true,
        responsive: [
            {
            breakpoint: 768,
                settings: {
                    arrows: false,
                }
            },
        ]
    });

    // collectin toggle
    $('.cstm-term-condition-toggle .cstm-term-condition-heading').click(function (e) {
        e.preventDefault();
        $('.cstm-term-condition-toggle .cstm-term-condition-content').slideToggle();
    });

    // mega menu
    $('.catering-menu').click(function (e) {
        $('details .cstm-default-open').each(function () {
            $(this).attr('open', true);
        });
        $('details .cstm-default-open .cstm-headerlink').each(function () {
            $(this).click(false);
        });
    });

    // 
    $('.cstm-dropdown-link-cm').click(function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        window.location.href = url ;
    });

/*-----------12-03-2026--------------*/
    $('.classic-peranakan .cstm-pro-grid-item-des span.price-item').each(function(){
    var cstm_withcurrency_price = $(this).text();
    var replace = cstm_withcurrency_price.replace('SGD', '');
        console.log(replace);
    $(this).text(replace);
});
    
});



// ------------------landing-slider-js----------------------
document.addEventListener("DOMContentLoaded", function () {
  $('.ny-slider .festive-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    autoplay: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});



// ------------------landing-slider-js----------------------
document.addEventListener("DOMContentLoaded", function () {
  $('.festive-slider').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    autoplay: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});




/*---------------------modal------------------------*/
  document.addEventListener("DOMContentLoaded", function () {
    const popup = document.getElementById("christmas-popup");
    const closeBtn = document.getElementById("close-popup");

    // Show popup on page load
    popup.style.display = "flex";

    // Close popup
    closeBtn.addEventListener("click", function () {
      popup.style.display = "none";
    });
  });





  $('a[href]').each(function () {
  var href = $(this).attr('href');

  if (!href || href.startsWith('#') || href.startsWith('javascript:')) {
    return;
  }
  if (href.startsWith('/')) {
    return;
  }
  if (href.startsWith('https://penangculture.com.sg')) {
    return;
  }

  $(this).attr({
    target: '_blank',
    rel: 'noopener noreferrer'
  });
});




/*--------------------text-remove---------------------*/

